const fromdata = [{
		title: "",
		modelvalue: "",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#424E66",
		lableheight: 0,
		types: "text",
		placeholder: "请输入文件名称",
		width: 916,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 0,
		X: false,
	},
	{
		title: "",
		modelvalue: "",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#424E66",
		lableheight: 0,
		types: "text",
		placeholder: "请选择发送对象(不选默认所有人)",
		width: 850,
		height: 32,
		disabled: true,
		marginLeft: 5,
		marginTop: 0,
		X: false,
	},{
		title: "",
		modelvalue: "",
		inputtype: "cascaderNodeParent",
		inputflag: true,
		fontSize: 14,
		multiple:false,
		color: "#424E66",
		lableheight: 0,
		types: "select",
		placeholder: "请选择文件类型",
		width: 948,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 5,
		X: false,
		options:[]
	},
	// {
	//   title: "",
	//   modelvalue: [],
	//   inputtype: "selectMultiple",
	//   inputflag: true,
	//   fontSize: 14,
	//   color: "#424E66",
	//   lableheight: 5,
	//   types: "text",
	//   placeholder: "请选择发送对象(不选默认所有人)",
	//   width: 948,
	//   // height: 0,
	//   disabled: false,
	//   marginLeft: 5,
	//   marginTop: 0,
	//   X: false,
	//   event: "InforSelectChange",
	//   remoteMethod: 'PublishremoteMethod',
	//   loading: false,
	//   options: []
	// },
];
export default fromdata;
